module.exports = __webpack_public_path__ + "img/razzo4.412d6459.png";